module.exports = __webpack_public_path__ + "assets/img/signature.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/signature.jpg
// module id = 1976
// module chunks = 0